import AssetPath from "../../AssetPath/AssetPath";
import PageTitle from "../../Components/PageTitle/PageTitle";
import FAQList from "../FAQ/FAQList";
import CTA from "../LandingPage/CTA";
import "./Sponsors.scss";
import SponsorPackages from "./SponsorPackages";
// import EventPartners from "../LandingPage/EventPartners";
import OurPartners from "../LandingPage/OurPartners";
import { Col, Row } from "antd";

export default function Sponsors() {
  return (
    <>
      <PageTitle
        mainTitle="Sponsors"
        breadcrumbItems={[{ name: "Sponsors", path: "/sponsors" }]}
        image={AssetPath.breadcrumb.sponsorsImage}
      />

      <SponsorPackages className="spacing-bottom" />

      <section className="who-we-are spacing bg-primary">
        <div className="container">
          <Row
            gutter={[
              { xs: 10, sm: 16, md: 24, lg: 24 },
              { xs: 10, sm: 16, md: 24, lg: 24 },
            ]}
            justify="center"
            align="middle"
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 18 }}
              md={{ span: 18 }}
              lg={{ span: 18 }}
              data-aos="fade-up"
            >
              <h4 className="title mb-3 text-white fw-bold">
                WHY BECOME A SPONSOR?
              </h4>
              <p className="text-white">
                The conference is set to host approximately 300 industry
                professionals.
              </p>
              <p className="text-white">
                Attendees represent a diverse mix of manufacturers and suppliers
                across various functional domains
              </p>
              <p className="text-white">
                Seize an unique opportunity to engage in direct, face-to-face
                interactions allowing organizations to showcase their
                capabilities and establish meaningful connections.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      {/* <EventPartners className="spacing-bottom" /> */}

      <OurPartners className="spacing-bottom" />

      <FAQList />

      <CTA
        subTitle="Become a Sponsor at the Annual Conference 2025"
        desc={
          <>
            <p>
              Elevate your brand’s presence in the pharma industry. Join
              industry leaders as a sponsor at{" "}
              <span className="strong">Annual Conference 2025</span>. Showcase
              your brand, connect with key decision-makers, and gain exclusive
              visibility.{" "}
            </p>
            <p>Contact us to explore sponsorship opportunities and benefits.</p>
          </>
        }
        label="Explore Sponsorship "
        image={AssetPath.breadcrumb.subscribeNewsletter}
        noImage
      />
    </>
  );
}
